module.exports = __webpack_public_path__ + "static/img/img02.7f98a16.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv019/img02.gif
// module id = 1Eyk
// module chunks = 0